/** @format */

import React, { useEffect, useState, useRef } from 'react';
import { withRouter } from 'react-router';
import AccordionServAcc from 'components/navigation/AccordionServAccr';
import { Row } from 'components/ui/Grid';
import Text from 'components/ui/Text';
import Wrapper from 'components/navigation/NavigationWrapper';
import { connect } from 'react-redux';
import Breadcrumbs from 'components/navigation/Breadcrumbs';
import { graphqlRequest, resetField } from 'redux-modules/actions/authActions';
import Loader from 'components/ui/Loader';
import checkEnte from 'utils/functions/checkEnte';
import checkAdmin from 'utils/functions/checkAdmin';
import RedirectAdmin from 'components/router/RedirectAdmin';
import withAuthentication from 'hoc/withAuthentication';
import { PAGE_HOME_URL } from 'types/url';
import PropTypes from 'prop-types';
import { parseData, getModificable } from './utils';
import { EstraiDettaglioAmministrativoServizioEnte as EstraiDettaglioAmministrativoServizioEnteQ } from './EntGOI005GraphQL';

const ServiziAccr = ({
  userProfile,
  EstraiDettaglioAmministrativoServizioEnte,
  locale,
  graphqlRequest: graphqlRequestFunction,
  match,
  ReadOnly,
  history,
}) => {
  const [formGoi005, setFormGoi005] = useState();

  const { datiLogin } = userProfile;
  const { idEnte, idServizio } = match.params;

  const firstDataFetch = useRef(true);

  const estraiDati = React.useCallback(() => {
    setFormGoi005(null);
    graphqlRequestFunction(EstraiDettaglioAmministrativoServizioEnteQ(idServizio, idEnte));
  }, [graphqlRequestFunction, idEnte, idServizio]);

  useEffect(
    () => {
      estraiDati();
    },
    []
  );

  useEffect(
    () => {
      if (firstDataFetch.current) {
        firstDataFetch.current = false;
        return;
      }

      const state = parseData(EstraiDettaglioAmministrativoServizioEnte, locale);
      const listaServizi = EstraiDettaglioAmministrativoServizioEnte.EstraiServizioErogatoEnte004;

      let cdStato;
      for (let index = 0; index <= listaServizi.length; index += 1) {
        const servizio = listaServizi[index];

        if (servizio.id_servizio_ente == idServizio) {
          cdStato = servizio.cd_stato_dati_servizio_ente;
          break;
        }
      }

      state.cdStatoDati = cdStato;
      // const datiLogin = sessionStorage.getItem('DatiLogin') && JSON.parse(sessionStorage.getItem('DatiLogin'));
      state.datiLogin = datiLogin;
      if (ReadOnly) {
        state.modifica = { campi: false, note: false };
      } else {
        state.modifica = getModificable(cdStato, datiLogin.Profilo);
      }
      setFormGoi005(state);
    },
    [EstraiDettaglioAmministrativoServizioEnte]
  );

  const BreadcrumbPath = [
    {
      slash: 'Home',
      url: '',
    },
    {
      slash: 'Area personale',
      url: 'AreaPersonale',
    },
    {
      slash: 'Servizi erogati',
      url: `gestioneEnte/${window.location.pathname.split('/gestioneEnte/')[1].split('/SchedaServiziEnte/')[0]}/SchedaServiziEnte`,
    },
    {
      slash: 'Gestione Scheda servizio enti',
      url: 'gestioneEnte',
    },
  ];

  if (!checkEnte(datiLogin)) {
    history.push(PAGE_HOME_URL);
  }

  const validitaEnte = checkEnte(datiLogin);
  const validitaAdmin = checkAdmin(datiLogin);

  let content = null;

  if (!validitaEnte && !validitaAdmin) {
    content = <RedirectAdmin />;
  } else if (!EstraiDettaglioAmministrativoServizioEnte || !formGoi005) {
    content = <Loader />;
  } else {
    content = (
      <>
        <Breadcrumbs value="Breadcrumb.page" pathSlashes={BreadcrumbPath} />
        <Row fluid padding="20px">
          <Text size="f3" value="Scheda " color="darkGrey" transform="uppercase" letterSpacing="0.05em" padding="0 0.5em 0 0" />
          <Text size="f3" value="Servizio" color="darkGrey" transform="uppercase" letterSpacing="0.05em" padding="0 0.5em 0 0" />
          <Text
            size="f3"
            value={
              EstraiDettaglioAmministrativoServizioEnte?.EstraiDettaglioAmministrativoServizioEnte?.service?.txTitoloServizio
                ? EstraiDettaglioAmministrativoServizioEnte.EstraiDettaglioAmministrativoServizioEnte.service.txTitoloServizio[locale]
                : null
            }
            color="darkGrey"
            transform="uppercase"
            weight="bold"
            padding="0 0.5em 0 0"
          />
          <Text size="f3" value="Ente" color="darkGrey" transform="uppercase" letterSpacing="0.05em" padding="0 0.5em 0 0" />
          <Text
            size="f3"
            value={EstraiDettaglioAmministrativoServizioEnte?.EstraiDettaglioAmministrativoServizioEnte?.ente?.nm_ente}
            color="darkGrey"
            transform="uppercase"
            letterSpacing="0.05em"
            weight="bold"
            padding="0 0.5em 0 0"
          />
        </Row>
        <Row>
          <AccordionServAcc Form={formGoi005} ReadOnly={ReadOnly} estraiDati={estraiDati} />
        </Row>
      </>
    );
  }

  return <Wrapper>{content}</Wrapper>;
};

ServiziAccr.propTypes = {
  EstraiDettaglioAmministrativoServizioEnte: PropTypes.shape({
    EstraiDettaglioAmministrativoServizioEnte: PropTypes.shape({
      ente: PropTypes.shape({
        nm_ente: PropTypes.string.isRequired,
      }),
      service: PropTypes.shape({
        txTitoloServizio: PropTypes.objectOf(PropTypes.string),
      }),
    }),
    EstraiServizioErogatoEnte004: PropTypes.arrayOf(
      PropTypes.shape({
        cd_stato_dati_servizio_ente: PropTypes.string.isRequired,
        id_servizio_ente: PropTypes.string.isRequired,
      })
    ),
  }),
  graphqlRequest: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  locale: PropTypes.string.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      idEnte: PropTypes.string.isRequired,
      idServizio: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  ReadOnly: PropTypes.bool,
  userProfile: PropTypes.shape({
    datiLogin: PropTypes.shape({
      Profilo: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

ServiziAccr.defaultProps = {
  EstraiDettaglioAmministrativoServizioEnte: null,
  ReadOnly: false,
};


const mapDispatchToProps = {
  graphqlRequest,
  resetField,
};

const mapStoreToProps = store => ({
  locale: store.locale,
  EstraiDettaglioAmministrativoServizioEnte: store.graphql.EstraiDettaglioAmministrativoServizioEnte,
  goi005: store.goi005,
});

ServiziAccr.displayName = 'ServiziAccr';
const ServiziAccreWithAuth = withAuthentication(ServiziAccr);
export default connect(
  mapStoreToProps,
  mapDispatchToProps
)(withRouter(ServiziAccreWithAuth));
